import { Controller } from "@hotwired/stimulus";

export class NavController extends Controller {
  static targets = ["menu","button"];

    toggle(){
      const isHidden = this.menuTarget.classList.toggle("hidden") === true;
      this.buttonTarget.setAttribute("aria-expanded", String(!isHidden));
    }

    // NUEVO: cierra el menú móvil
    close(){
      if (!this.menuTarget.classList.contains("hidden")) {
        this.menuTarget.classList.add("hidden");
        this.buttonTarget.setAttribute("aria-expanded","false");
      }
    }

    // Cierra si se hace click en un link del nav (delegado)
    onNavClick(e){
      const a = e.target.closest("a[href]");
      if (!a) return;
      // Solo aplica en móvil (menú desplegable)
      if (!window.matchMedia("(min-width: 768px)").matches) this.close();
    }

    // Cierra si haces click fuera del header (móvil)
    onDocumentClick(e){
      if (window.matchMedia("(min-width: 768px)").matches) return;
      if (!this.element.contains(e.target)) this.close();
    }

    // Cierra si cambias a md+ (evita que quede abierto al rotar/resize)
    onResize(){
      if (window.matchMedia("(min-width: 768px)").matches) this.close();
    }
}
